import { BOARD_WIDTH, BOARD_HEIGHT } from './constants';
import { Piece } from './state';
import { getCells } from './piece';

export function isValidPosition(board: number[][], piece: Piece): boolean {
  const cells = getCells(piece);
  for (const [x, y] of cells) {
    // Allow cells above the board (spawning area)
    if (x < 0 || x >= BOARD_WIDTH) return false;
    if (y >= BOARD_HEIGHT) return false;
    if (y >= 0 && board[y][x] !== 0) return false;
  }
  return true;
}

export function isOnGround(board: number[][], piece: Piece): boolean {
  const testPiece = { ...piece, y: piece.y + 1 };
  return !isValidPosition(board, testPiece);
}

export function lockPiece(board: number[][], piece: Piece): void {
  const cells = getCells(piece);
  for (const [x, y] of cells) {
    if (y >= 0 && y < BOARD_HEIGHT) {
      board[y][x] = piece.type;
    }
  }
}

export function clearLines(board: number[][]): number {
  let linesCleared = 0;

  for (let y = BOARD_HEIGHT - 1; y >= 0; y--) {
    if (board[y].every(cell => cell !== 0)) {
      // Remove the line
      board.splice(y, 1);
      // Add empty line at top
      board.unshift(new Array(BOARD_WIDTH).fill(0));
      linesCleared++;
      y++; // Check this row again since we shifted everything down
    }
  }

  return linesCleared;
}

export function getGhostY(board: number[][], piece: Piece): number {
  let ghostY = piece.y;
  while (isValidPosition(board, { ...piece, y: ghostY + 1 })) {
    ghostY++;
  }
  return ghostY;
}

export function isTopOut(board: number[][], piece: Piece): boolean {
  // Game over if piece locks with any cell above visible area
  const cells = getCells(piece);
  return cells.some(([_, y]) => y < 0);
}
